import React from "react";
import classNames from "classnames";
import "./OpticksIconArea.css";

interface Props {
  icon: React.ReactNode;
  type?: "rounded" | "circle";
}

const OpticksIconArea = ({ icon, type = "rounded" }: Props) => {
  return (
    <div
      className={classNames("opticks-icon-area", { [`type-${type}`]: type })}
    >
      {icon}
    </div>
  );
};

export default OpticksIconArea;
